import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Menu, MenuItem, Fade } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';

import { GetIndiChallenges } from "../../redux/indiChallenge/actions";

import CustomTableV2 from "../../common/CustomTableV2";

import "./style.css";
import moment from "moment";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";

function IndiChallenge(props) {
    const [showModal, setShowModal] = useState(false);
    const [selectedChallenge, setSelectedChallenge] = useState(null);

    // MENU STATES
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentIndex, setCurrentIndex] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="main-container" id="indi-challenge">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="INDI CHALLENGES"
                        description=""
                        store={props.IndiChallenge}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Title" },
                                { title: "Start" },
                                { title: "End" },
                                { title: "Type" },
                                { title: "" },
                                { title: "Unit" },
                                { title: "Milestone" },
                                { title: "" },
                            ],
                            body: (ic, i) => {
                                let type = "", subtype = "";
                                if (ic?.company) {
                                    type = "Company Challenge";
                                } else if (ic?.program) {
                                    type = "Program Challenge";
                                    subtype = ic?.program_title;
                                } else if (ic?.type == "all") {
                                    type = "All";
                                } else {
                                    type = "Program Type";
                                    subtype = ic?.type;
                                }

                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{ic?.title?.toUpperCase()}</h5></td>
                                        <td><h5>{ic?.startdate ? moment(ic?.startdate).format("YYYY-MM-DD") : "-"}</h5></td>
                                        <td><h5>{ic?.enddate ? moment(ic?.enddate).format("YYYY-MM-DD") : "-"}</h5></td>
                                        <td><h5>{type?.toUpperCase()}</h5></td>
                                        <td><h5>{subtype?.toUpperCase()}</h5></td>
                                        <td><h5>{ic?.unit?.toUpperCase()}</h5></td>
                                        <td><h5>{ic?.milestone}</h5></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            setSelectedChallenge(ic);
                                                            setShowModal(true);
                                                            handleClose();
                                                        }}><EditIcon sx={{ mr: '10px' }} /> Edit</MenuItem>
                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetIndiChallenges(page, count, filter, sort);
                            },
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"Indi Challenge"}>
            </CustomSliderModalV2>

        </div>
    );
}

const mapStateToProps = (state) => ({
    IndiChallenge: state.IndiChallenge,
})

export default connect(mapStateToProps, {
    GetIndiChallenges,
})(IndiChallenge);
